
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { translate } from './translateFunction';
import './buttonAnimations.scss';
import './UserRequest.css'; // CSS-Datei für den Ladebalken

const CustomerFeedback = () => {
  const [company, setCompany] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isTrans, setIsTrans] = useState(false);
  const [showProgressBar, setShowProgressBar] = useState(false);

  const navigate = useNavigate();

  const [translations, setTranslations] = useState({
    feedbackRequestTitle: '',
    fillFields: '',
    customerCompanyLabel: '',
    contactPersonLabel: '',
    emailLabel: '',
    generateFeedbackRequest: '',
    cancel: '',
    submitting: '',
    successMessage: '',
    successMessagetwo: '',
  });

  React.useEffect(() => {
    const loadTranslations = async () => {
      const feedbackRequestTitle = await translate(70);
      const fillFields = await translate(71);
      const customerCompanyLabel = await translate(72);
      const contactPersonLabel = await translate(73);
      const emailLabel = await translate(74);
      const generateFeedbackRequest = await translate(75);
      const cancel = await translate(76);
      const submitting = await translate(77);
      const successMessage = await translate(420);
      const successMessagetwo = await translate(421);

      setTranslations({
        feedbackRequestTitle,
        fillFields,
        customerCompanyLabel,
        contactPersonLabel,
        emailLabel,
        generateFeedbackRequest,
        cancel,
        submitting,
        successMessage,
        successMessagetwo,
      });
    };

    loadTranslations();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setShowProgressBar(true);
    setTimeout(() => {
      setIsTrans(true);
    }, 200); // Delay for animation

    const token = localStorage.getItem('token');

    try {
      // Der Server erzeugt den Feedback-Link, speichert ihn und schickt ihn per Mail an den angemeldeten Benutzer
      await axios.post(
        '/api/customerFeedback',
        {
          customerCompany: company,
          customerName: contactPerson,
          customerMailaddr: email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      setTimeout(() => {
        setSubmitted(true);
        setIsSubmitting(false);
        setTimeout(() => navigate('/user'), 3000);
      }, 500);
    } catch (error) {
      console.error('An error occurred:', error.response?.data || error.message);
      alert(error.response?.data || 'Error sending feedback.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      {showProgressBar && <div className="progress-bar"></div>}
      <section className="featured">
        <div className="content-wrapper banner">
          <div className="float-right">
            <img className="page-icon" src="/Content/themes/base/images/Speak.png" alt="Speak icon" />
          </div>
          <hgroup className="title">
            <h1>{translations.feedbackRequestTitle}</h1>
            <p>{translations.fillFields}</p>
          </hgroup>
        </div>
      </section>
      <div className="container mt-5">
        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>{translations.customerCompanyLabel}</label>
              <input
                type="text"
                className="form-control"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                placeholder={translations.customerCompanyLabel}
                required
              />
            </div>
            <div className="form-group">
              <label>{translations.contactPersonLabel}</label>
              <input
                type="text"
                className="form-control"
                value={contactPerson}
                onChange={(e) => setContactPerson(e.target.value)}
                placeholder={translations.contactPersonLabel}
                required
              />
            </div>
            <div className="form-group">
              <label>{translations.emailLabel}</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={translations.emailLabel}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary button"
              disabled={isSubmitting}
            >
              {isSubmitting ? translations.submitting : translations.generateFeedbackRequest}
            </button>
            {!isSubmitting && (
              <button type="button" className="btn btn-secondary ml-3" onClick={() => navigate('/user')}>
                {translations.cancel}
              </button>
            )}
          </form>
        ) : (
          <div className={`feedback-success-message ${isTrans ? 'transition' : ''}`} style={{ textAlign: 'center' }}>
            <div className="checkmark">&#10003;</div>
            <h3>
              {translations.successMessagetwo}
              <br />
              {translations.successMessage}
            </h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerFeedback;
